<template>
  <div ref="totalRef" class="subpage">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" :title="Title" :is-sub-page="true"></Header>
    <div ref="contentRef" class="container">
      <div class="forecast-result">
        <div class="forecast-msg">
          <span :style="span[0]" class="subtitle">公历:<nobr>{{time[0]}}</nobr></span>
          <span :style="span[1]" class="subtitle">农历:<nobr>{{time[1]}}</nobr></span>
          <span :style="span[2]" class="subtitle">四柱:<nobr>{{time[2]}}</nobr></span>
        </div>
        <SpaceHolder spaceheight="10"></SpaceHolder>
        <div class="forecast-img">
          <span>
            <h3>本卦</h3>
            <div class="img-item">
              <ForecastItem :items="itemList[0]"></ForecastItem>
            </div>
            <h1>{{forecastTitle[0]}}</h1>
          </span>
          <span>
            <h3>互卦</h3>
            <div class="img-item">
              <ForecastItem :items="itemList[1]"></ForecastItem>
            </div>
            <h1>{{forecastTitle[1]}}</h1>
          </span>
          <span>
            <h3>变卦</h3>
            <div class="img-item">
              <ForecastItem :items="itemList[2]"></ForecastItem>
            </div>
            <h1>{{forecastTitle[2]}}</h1>
          </span>
        </div>
        <SpaceHolder spaceheight="10"></SpaceHolder>
        <router-link :to="{path: '/plum/forecastresult', query:{platform: $route.query.platform, title: forecastTitle[0],content:forecastContent[0]}}" @click.native="setForecastResult({res:forecastTitle[0],content:forecastContent[0]})">

          <div class="forecast-link">
            <h3 class="subtitle">{{forecastTitle[0]}}</h3>
            <img :src="imgSrc"/>
          </div>

        </router-link>
        <SpaceHolder spaceheight="5"></SpaceHolder>
        <router-link :to="{path: '/plum/forecastresult', query:{platform: $route.query.platform, title: forecastTitle[1],content:forecastContent[1]}}" @click.native="setForecastResult({res:forecastTitle[1],content:forecastContent[1]})">
          <div class="forecast-link">
            <h3 class="subtitle">{{forecastTitle[1]}}</h3>
            <img :src="imgSrc"/>
          </div>
        </router-link>
        <SpaceHolder spaceheight="5"></SpaceHolder>
        <router-link :to="{path: '/plum/forecastresult', query:{platform: $route.query.platform, title: forecastTitle[2],content:forecastContent[2]}}" @click.native="setForecastResult({res:forecastTitle[2],content:forecastContent[2]})">
          <div class="forecast-link">
            <h3 class="subtitle">{{forecastTitle[2]}}</h3>
            <img :src="imgSrc"/>
          </div>
        </router-link>

      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import Header from '@/components/Header'
import SpaceHolder from '../../components/SpaceHolder'
import ForecastItem from '../../components/ForecastItem'
import { queryMeihua } from '@/api/test'

export default {
  name: 'ReportResult',
  components: {
    Header,
    SpaceHolder,
    ForecastItem
  },
  data () {
    return {
      backgroundUrl: '',
      span: ['display: flex;align-items: flex-start', 'display: flex;align-items: center', 'display: flex;align-items: flex-end'],
      time: [''],
      imgSrc: require('@/assets/images/icons/icon-next.png'),
      forecastItem: {
        itemOne: [],
        itemTwo: [],
        itemThr: []
      },
      forecastTitle: ['', '', ''],
      forecastContent: [null, null, null]
    }
  },
  beforeMount () {
    this.getData()
  },
  mounted () {
    document.title = this.$route.query.title
  },
  methods: {
    getData () {
      console.log('test getData')
      console.log('num1=' + this.$store.state.common.num1 + ' num2=' + this.$store.state.common.num2)
      queryMeihua({ num1: this.$store.state.common.num1, num2: this.$store.state.common.num2 })
        .then((res) => {
          // 日历
          this.time.splice(0)
          this.time.push(res.data.gregorianCalendar.trim())
          this.time.push(res.data.lunarCalendar.trim())
          this.time.push(res.data.pillars.trim())
          // 卦
          this.forecastItem.itemOne.splice(0)
          this.forecastContent[0] = res.data.basicDiagrams.content

          res.data.basicDiagrams.content.reverse().forEach((v, idx) => {
            console.log('idx=' + idx + '  v=' + v)
            this.forecastItem.itemOne.push(v > 1 ? 'itemTwo' : 'itemOne')
          })

          this.forecastItem.itemTwo.splice(0)
          this.forecastContent[1] = res.data.complementedDiagrams.content
          res.data.complementedDiagrams.content.reverse().forEach((v, idx) => {
            this.forecastItem.itemTwo.push(v > 1 ? 'itemTwo' : 'itemOne')
          })

          this.forecastItem.itemThr.splice(0)
          this.forecastContent[2] = res.data.variationDiagrams.content
          res.data.variationDiagrams.content.reverse().forEach((v, idx) => {
            this.forecastItem.itemThr.push(v > 1 ? 'itemTwo' : 'itemOne')
          })

          // 名称
          console.log('1:' + res.data.basicDiagrams.title.trim() + '  2:' + res.data.complementedDiagrams.title.trim() +
              '  3:' + res.data.variationDiagrams.title.trim())
          this.forecastTitle.splice(0)
          var str = res.data.basicDiagrams.title.trim()
          var idx = str.indexOf('(') < 0 ? str.indexOf('（') : str.indexOf('(')
          str = str.substr(0, idx)
          this.forecastTitle.push(str)
          str = res.data.complementedDiagrams.title.trim()
          idx = str.indexOf('(') < 0 ? str.indexOf('（') : str.indexOf('(')
          str = str.substr(0, idx)
          this.forecastTitle.push(str)
          str = res.data.variationDiagrams.title.trim()
          idx = str.indexOf('(') < 0 ? str.indexOf('（') : str.indexOf('(')
          str = str.substr(0, idx)
          this.forecastTitle.push(str)
        })
    },
    setForecastResult (result) {
      this.$store.commit('setForecastResult', result.res)
      this.$store.commit('setForecastContent', result.content)
    }
  },
  computed: {
    // 顶部导航信息
    Title () {
      return this.$store.state.common.Forecast
    },
    // 起卦图片的数据
    itemList () {
      return Object.values(this.forecastItem)
    }
  }
}
</script>

<style lang="stylus" scoped>
.subpage
  background url("~@/assets/images/backgrounds/bg.png") no-repeat center
  background-size 100% 100%

  .forecast-result
    padding 15px
    width: 100%
    box-sizing: border-box
  .forecast-img, .forecast-msg, .forecast-link
    width 100%
    background #fff
  .forecast-msg
    height 119.5px
    padding 23px 20px
    display flex
    flex-direction column
    box-sizing border-box
    span
      flex-grow 1
      text-align start
    nobr
      margin-left 24px
  .forecast-img
    height 156px
    padding 15px 28px
    display flex
    flex-direction row
    box-sizing border-box
    span
      flex-grow 1
      position relative
    h1
      font-size 15px
      font-weight 400
      color #545454
      line-height 21px
      margin 20px auto 0 auto
    h3
      font-size 12px
      font-weight 400
    .img-item
      width 66px
      height 54px
      margin 15px auto
  .forecast-link
    position relative
    height 60px
    box-sizing border-box
    padding 19px 16.5px 19px 23px
    h3
      position absolute
      left 23px
    img
      position absolute
      right 16.5px
      width 13.5px
      height 22.5px
  .subtitle
    line-height 21px
    font-size 15px
    color #545454
</style>

<style lang="stylus">
body
  background-color #EFE9E0
</style>
